// removed by extract-text-webpack-plugin
module.exports = {"block":"Icon__block-2mJ73","svg":"Icon__svg-BJaz9"};